import { Logger } from '@/utils/logger';
import { useCallback } from 'react';
import TagManager from 'react-gtm-module';

const logger = new Logger('useGoogleAnalytics.ts');
declare global {
  interface Window {
    gtag?: (command: 'event', eventName: string, params: Record<string, unknown>) => void;
  }
}

// Plain-function form of the gtag seam, for callers outside React (e.g. the
// product quantity store's cart events).
export const sendGoogleAnalyticsGTagEvent = (eventCategory: string, params: Record<string, unknown>) => {
  window.gtag?.('event', eventCategory, params);
};

const useGoogleAnalytics = () => {
  const sendGoogleAnalyticsEvent = useCallback((eventName: string, params: Record<string, unknown>) => {
    logger.debug('Sending Google Analytics event', eventName, params);

    TagManager.dataLayer({
      dataLayer: {
        ...params,
        event: eventName,
      },
    });
  }, []);

  return { sendGoogleAnalyticsEvent, sendGoogleAnalyticsGTagEvent };
};

export default useGoogleAnalytics;
